// extracted by mini-css-extract-plugin
export default {"homeTitle":"title_rem_homeTitle__RRovU"};